import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {COARSE, TOUCH_MIN} from "../../../../../theme/modern/touchTargets"

/** Ported from the prototype's `record.css` `.measurebar` block. */
export default makeStyles((theme: ModernTheme) => ({
    bar: {
        // Absolute against the stage WRAPPER, not the stage itself: the stage
        // scrolls, and a bar positioned inside it would slide out of view the
        // moment the reviewer scrolled down the 12-lead figure.
        position: "absolute",
        bottom: 14,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 8,
        width: "max-content",
        maxWidth: "calc(100% - 24px)",
        display: "flex",
        alignItems: "center",
        gap: "9px",
        background: theme.modern.panel,
        border: `1px solid ${theme.modern.accentLine}`,
        borderRadius: 9,
        boxShadow: theme.modern.shadow,
        padding: "6px 8px 6px 12px",
    },
    value: {
        font: `600 12px ${theme.modern.mono}`,
        color: theme.modern.accent,
        whiteSpace: "nowrap",
    },
    note: {
        font: `400 11px ${theme.modern.sans}`,
        color: theme.modern.ink3,
        whiteSpace: "nowrap",
    },
    apply: {
        appearance: "none",
        font: `500 12px ${theme.modern.sans}`,
        color: theme.modern.ink,
        background: theme.modern.panel2,
        border: `1px solid ${theme.modern.line}`,
        borderRadius: 7,
        padding: "5px 9px",
        cursor: "pointer",
    },
    close: {
        width: 24,
        height: 24,
        display: "grid",
        placeItems: "center",
        borderRadius: 6,
        color: theme.modern.ink3,
        fontSize: 15,
        lineHeight: 1,
        border: "none",
        background: "none",
        cursor: "pointer",

        "&:hover": {
            background: theme.modern.critSoft,
            color: theme.modern.crit,
        },
        "&:active": {background: theme.modern.critSoft, color: theme.modern.crit},

        // dismisses a caliper reading, so it is on the direct path of the touch
        // workflow the pointer-event rewrite just opened up
        [COARSE]: {width: TOUCH_MIN, height: TOUCH_MIN},
    },
}))
